module.exports = __webpack_public_path__ + "static/media/service-center-part-accessories-genuine.77538075.jpg";